import { vmFollowItem } from './../components';

export const updateIcon = (userId, isFollowing) => {
  vmFollowItem.$data.value = !isFollowing || userId === undefined ? 0 : userId;
};
